import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { EyeIcon, ServicePauseIcon, ServicePriceIcon, ServiceTimeIcon, TrashIcon } from '../../../../assets/svg/iconos';
import { formatCurrency } from '../../../../helpers/helpers';
import useClickOutside from '../../../../hooks/useClickOutside';
import { useServiceImage } from '../../../../hooks/useServiceImage';

export const ServicioCard = ({servicio, editServicio, deleteServicio}) => {
    const { colores } = useSelector(state => state.ui);
    const { sucursales } = useSelector(state => state.sucursales);

    const imageUrl = useServiceImage(servicio);

    const popover = useRef();
    const [isOpen, toggle] = useState(false);

    const close = useCallback(() => toggle(false), []);
    useClickOutside(popover, close);

    const [sucursalesText, setSucursalesText] = useState('');

    const clickSelect = () => {
        toggle( !isOpen );
    }

    useEffect(() => {
        if (servicio?._id && sucursales?.length) {
            let seleccionadas = 0;
            sucursales.forEach(sucursal => {
                if (servicio.sucursales?.includes(sucursal._id)) seleccionadas++;
            });
            setSucursalesText(seleccionadas === 0 ? 'Ninguna' : seleccionadas === sucursales.length ? 'Todas' : 'Varias');
        }
    }, [servicio, sucursales]);
    
    return (
        <div 
            className='servicio-card'
            onClick={ clickSelect }
        >
            <div className='card-main'>
                <div 
                    className='servicio-img'
                    style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : 'none' }}
                ></div>
                <div className='servicio-title' style={{ color: colores.colorPrincipal }}>
                    <p>{ servicio.nombre }</p>
                </div>
                <div className='servicio-description'>
                    <p>{ servicio.descripcion }</p>
                </div>
                <div className='servicio-sucursales'>
                    <p>Sucursales: <span>{ sucursalesText }</span></p>
                </div>
            </div>
            <footer
                style={{ backgroundColor: colores.colorPrincipal }}
            >
                <div className='footer-left'>
                    <div className='time'>
                        <ServiceTimeIcon />
                        { servicio.duracion }'
                    </div>
                    {
                        servicio.pausa &&
                        <div className='pauses'>
                            <ServicePauseIcon />
                            45'
                        </div>
                    }
                </div>
                <div className='footer-right'>
                    <div className='price'>
                        <ServicePriceIcon />
                        { formatCurrency(servicio.precio) }
                    </div>
                    {
                        servicio.descuento &&
                        <div 
                            className='discount'
                            style={{ color: colores.colorSecundario }}
                        >
                            -10%
                        </div>
                    }
                </div>
            </footer>
            {
                isOpen && (
                    <div className='servicio-overlay' ref={popover}>
                        <div className='overlay-buttons'>
                            <button 
                                className='eye'
                                onClick={ () => editServicio( servicio ) }
                            >
                                <EyeIcon color={ colores.colorPrincipal } />
                            </button>
                            <button 
                                className='trash'
                                onClick={ () => deleteServicio( servicio ) }
                            >
                                <TrashIcon color={ colores.colorPrincipal } />
                            </button>
                        </div>
                    </div>
                )
            }
        </div>
    )
}
